import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GetSiteGQL, GetPartnerPagesGQL, DeletePartnerPageGQL } from '../../graphql/graphql';
import { ToastService } from '../../shared/toast/toast.service';

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
    standalone: false
})
export class PagesComponent implements OnInit {
  siteUrl: string = '';
  siteId: string = '';
  pages: any[] = [];
  loading = true;
  showDeleteModal = false;
  pageToDelete: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private getSiteGQL: GetSiteGQL,
    private getPartnerPagesGQL: GetPartnerPagesGQL,
    private deletePartnerPageGQL: DeletePartnerPageGQL,
    private toast: ToastService
  ) {}

  ngOnInit() {
    this.siteUrl = this.route.parent?.snapshot.params['url'] || '';
    this.loadSiteData();
  }

  loadSiteData() {
    if (this.siteUrl) {
      this.getSiteGQL.watch({ variables: { url: this.siteUrl, categoryId: '' } }).valueChanges.subscribe(result => {
        if (result.data?.site?._id) {
          this.siteId = result.data.site._id;
          this.getPartnerPagesGQL.watch({ variables: { siteId: this.siteId, type: 'page' }, fetchPolicy: 'network-only' }).valueChanges.subscribe(pagesResult => {
            if (pagesResult.data?.partnerPages) {
              this.pages = pagesResult.data.partnerPages.map(page => ({ ...page }));
            }
            this.loading = false;
          });
        }
      });
    }
  }

  addPage() {
    this.router.navigate(['page'], { relativeTo: this.route });
  }

  editPage(pageId: string) {
    this.router.navigate(['page', pageId], { relativeTo: this.route });
  }

  isProtectedPage(page: any): boolean {
    return ['404', '/404', 'home', '/'].includes(page.slug);
  }

  confirmDelete(page: any) {
    if (this.isProtectedPage(page)) return;
    this.pageToDelete = page;
    this.showDeleteModal = true;
  }

  cancelDelete() {
    this.showDeleteModal = false;
    this.pageToDelete = null;
  }

  deletePage() {
    if (this.pageToDelete) {
      this.deletePartnerPageGQL.mutate({
        variables: { id: this.pageToDelete._id },
        refetchQueries: [{ query: this.getPartnerPagesGQL.document, variables: { siteId: this.siteId, type: 'page' } }]
      }).subscribe({
        next: () => {
          this.showDeleteModal = false;
          this.pageToDelete = null;
          this.toast.success('Page deleted');
        },
        error: (err) => { console.error('Error deleting page:', err); this.toast.error('Error deleting page'); }
      });
    }
  }

  get orderedPages() {
    return [...this.pages].sort((a, b) => a.name.localeCompare(b.name));
  }
}
